<!DOCTYPE html>
<header class="fixed-top block">
  <div class="app-titel">
    <h1 class="marginBottomKlein"><a routerLink="/" style="color: black; text-decoration: none;">
      Upload für sequenzbasierte Untersuchung von Studien-/Projektproben</a></h1>
<!--    <img ngSrc="" alt="UKM Logo" height="100%" width="auto">-->
  </div>
  <div class="roteSubHeadline">Bitte senden Sie die Proben nur in 2,0 ml Reaktionsgefäßen ein und bekleben diese nicht mit Etiketten.</div>
</header>
<div id="main-area" class="block">
<!--  <div class="warnung">-->
<!--    Bitte beachten: die Proben werden nach Abschluss der Untersuchung nicht asserviert oder eingefroren!-->
<!--  </div>-->
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" color="accent" [selectedIndex]="selectedTab"
                 (selectedIndexChange)="selectedTab=$event">
<!--    <mat-tab [labelClass]="'tabUeberschrift'" label="Informationen">-->
    <mat-tab>
      <ng-template mat-tab-label> <h2>Informationen</h2>
    </ng-template>
      <app-informationen></app-informationen>

    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label> <h2>Probenliste</h2>
      </ng-template>
      <app-probenliste></app-probenliste>
    </mat-tab>
  </mat-tab-group>
  <router-outlet></router-outlet>
  <div id="submitButtonWrapper">
<!--<pre>-->
<!--    <p>-->
<!-- {{ selectedTab }}-->
<!--    </p>-->
<!--  </pre>-->
    <button *ngIf="selectedTab == 0"  mat-raised-button color="primary" (click)="selectedTab = 1">Zur Probenliste</button>
    <button *ngIf="selectedTab == 1"  mat-raised-button color="primary" (click)="selectedTab = 0">Zurück zu Informationen</button>
    <button id="submitButton" mat-raised-button color="primary" (click)="datenAbschicken()">Daten abschicken</button>
  </div>
</div>
